import { render, staticRenderFns } from "./AttestationTest.vue?vue&type=template&id=195ef30a&scoped=true&"
import script from "./AttestationTest.vue?vue&type=script&lang=js&"
export * from "./AttestationTest.vue?vue&type=script&lang=js&"
import style0 from "./AttestationTest.vue?vue&type=style&index=0&id=195ef30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ef30a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRadio,VRadioGroup,VRow})
